import { withTranslation } from 'react-i18next'
import Booking from './Booking'

export default withTranslation()(Booking)
